import { render, staticRenderFns } from "./ImprimantesWaxjet510.vue?vue&type=template&id=2a6a1a38&scoped=true"
import script from "./ImprimantesWaxjet510.vue?vue&type=script&lang=js"
export * from "./ImprimantesWaxjet510.vue?vue&type=script&lang=js"
import style0 from "./ImprimantesWaxjet510.vue?vue&type=style&index=0&id=2a6a1a38&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a6a1a38",
  null
  
)

export default component.exports